module.exports = __webpack_public_path__ + "media/images/icons/flash-2e288249c33a54b0e1ab69de81d12e0f.svg";